import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nProvider } from "./i18n/hook";
import ScrollToTop from "./components/feature/ScrollToTop";
import SeoManager from "./components/feature/SeoManager";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <SeoManager />
        <AppRoutes />
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;